export const ProductionSimulationLogisticTransportFrom = (
	json: IProductionSimulationLogisticTransportFrom,
): IProductionSimulationLogisticTransportFromModel => {
	const { socket_name, stage_name, ...rest } = json

	return {
		...rest,
		socketName: socket_name,
		stageName: stage_name,
	}
}

export const ProductionSimulationLogisticTransport = (
	json: IProductionSimulationLogisticTransport,
): IProductionSimulationLogisticTransportModel => {
	const { delivery_date, from, to, pickup_date, product_name, quantity, ...rest } = json

	return {
		...rest,
		deliveryDate: delivery_date,
		from: ProductionSimulationLogisticTransportFrom(from),
		to: ProductionSimulationLogisticTransportFrom(to),
		pickupDate: pickup_date,
		productName: product_name,
		quantity,
	}
}

export const ProductionSimulationLogistic = (
	json: IProductionSimulationLogistic,
): IProductionSimulationLogisticModel => {
	const { end_time, start_time, transports_count, transports, ...rest } = json

	return {
		...rest,
		endTime: end_time,
		startTime: start_time,
		transportsCount: transports_count,
		transports: transports.map(ProductionSimulationLogisticTransport),
	}
}
